<div class="inline" [ngClass]="{'pointer': openable}" (click)="open()">
  <div class="spacy bold" [ngClass]="{'text-primary': openable}">{{tag}}</div>
  <div class="small" *ngIf="displays.id && id">{{id | date : 'dd-MM-yyyy'}}</div>
  <div class="small" *ngIf="displays.stamp && stamp">{{stamp | date : 'dd-MM-yyyy'}}</div>
  <div class="small uppercase" *ngIf="displays.partner && partner">{{partner.Name}}</div>
</div>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
